(function(){
  var hero='https://cdn.shopify.com/s/files/1/0516/0117/8783/files/vs-home-hero.png?v=1783181959';
  function fixHero(){
    document.querySelectorAll('[id*=slideshow_jHz8Rk] .banner__media').forEach(function(m){
      m.style.setProperty('background','#E9ECEF','important');
      m.style.setProperty('background-image','none','important');
    });
    document.querySelectorAll('[id*=slideshow_jHz8Rk] .banner__media img').forEach(function(i){
      i.src=hero;
      i.srcset=hero;
      i.style.setProperty('opacity','1','important');
      i.style.setProperty('visibility','visible','important');
      i.style.setProperty('display','block','important');
      i.style.setProperty('width','100%','important');
      i.style.setProperty('height','100%','important');
      i.style.setProperty('object-fit','contain','important');
      i.style.setProperty('object-position','center','important');
      i.style.setProperty('background','#E9ECEF','important');
    });
  }
  function addHardHideStyle(){
    var st=document.getElementById('vs-remove-sternify-table-style');
    if(!st){
      st=document.createElement('style');
      st.id='vs-remove-sternify-table-style';
      st.textContent='[id*="st_table_k7RRrd"],[class*="st_table_k7RRrd"],.shopify-section[id*="st_table_k7RRrd"]{display:none!important;visibility:hidden!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;}';
      document.head.appendChild(st);
    }
  }
  function removeOldInjectedBlocks(){
    ['vs-st-table-k7RRrd','vs-safe-comparison','vs-cat-under-sternify','vs-sternify-cat-copy','vs-product-cat-copy'].forEach(function(id){
      var el=document.getElementById(id); if(el) el.remove();
    });
    ['vs-st-table-k7RRrd-style','vs-safe-comparison-style','vs-cat-under-sternify-style','vs-sternify-cat-copy-style','vs-product-cat-copy-style'].forEach(function(id){
      var el=document.getElementById(id); if(el) el.remove();
    });
  }
  function removeRealSternifyTable(){
    document.querySelectorAll('[id*="st_table_k7RRrd"],[class*="st_table_k7RRrd"]').forEach(function(el){el.remove();});
    document.querySelectorAll('section,div').forEach(function(el){
      var t=el.textContent||'';
      if(t.indexOf('Wir vs')>-1 && (t.indexOf('Vinted')>-1 || t.indexOf('Secondhand-Marktplätze')>-1) && t.indexOf('Andere Vintage')>-1){
        var s=el.closest('.shopify-section')||el;
        s.style.setProperty('display','none','important');
        s.style.setProperty('visibility','hidden','important');
        s.style.setProperty('height','0','important');
        s.style.setProperty('margin','0','important');
        s.style.setProperty('padding','0','important');
        s.style.setProperty('overflow','hidden','important');
      }
    });
  }
  function run(){fixHero();addHardHideStyle();removeOldInjectedBlocks();removeRealSternifyTable();}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',run):run();
  setTimeout(run,300);setTimeout(run,700);setTimeout(run,1500);setTimeout(run,3000);
})();